import { type RPPDomain } from 'utils/core/RPPCore.types'
import { NavItem } from 'legacy/components/Nav/nav.types'
import { insightsPortalRouter } from 'domains/insights-portal/routing/insightsPortalRouter'
import { type DomainMessages } from 'domains/insights-portal/utils/domain/intl'
import { routes } from 'domains/insights-portal/routing/routes'
import EN_US from 'domains/insights-portal/translations/en-US'
import { type DomainAccessControlConfig } from 'domains/insights-portal/utils/domain/accessControl'
import { insightsPortalAccessControl } from 'domains/insights-portal/access-control/insightsPortalAccess.configuration'
import { insightsPortalSummaryReportAccessControl } from 'domains/insights-portal/access-control/insightsPortalSummaryReportAccess.configuration'
import { insightsPortalAdsDashboardAccessControl } from 'domains/insights-portal/access-control/insightsPortalAdsDashboardAccess.configuration'
import { insightsPortalCampaignAnalyticsAccessControl } from 'domains/insights-portal/access-control/insightsPortalCampaignAnalytics.configuration'
import { insightsPortalAdsCampaignAccessControl } from 'domains/insights-portal/access-control/insightsPortalAdsCampaignAccess.configuration'
import { insightsPortalDataExplorerAccessControl } from 'domains/insights-portal/access-control/insightsPortalDataExplorerAccess.configuration'
import { insightsPortalCollectionsControl } from 'domains/insights-portal/access-control/insightsPortalCollections.configuration'
import { insightsPortalPlacementsAccessControl } from 'domains/insights-portal/access-control/insightsPortalPlacements.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'insights-portal',
  routes,
  translations: { EN_US },
  routers: {
    scoped: [insightsPortalRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.DataAndAnalytics,
      subNavItems: [
        {
          type: 'item',
          labelId: 'insightsPortalDomain.summaryReport.nav',
          route: 'insights-portal-executive-summary',
          accessControl: insightsPortalSummaryReportAccessControl,
        },
        {
          type: 'item',
          labelId: 'insightsPortalDomain.performance',
          route: 'insights-portal-performance',
          accessControl: insightsPortalAccessControl,
        },
        {
          type: 'item',
          labelId: 'insightsPortalDomain.adsDashboard.nav',
          route: 'insights-portal-ads-dashboard',
          accessControl: insightsPortalAdsDashboardAccessControl,
        },

        {
          type: 'item',
          labelId: 'insightsPortalDomain.campaignsAnalytics.nav',
          route: 'insights-portal-campaigns-analytics',
          accessControl: insightsPortalCampaignAnalyticsAccessControl,
        },
        {
          type: 'item',
          labelId: 'insightsPortalDomain.collections.nav',
          route: 'insights-portal-collections-insights',
          accessControl: insightsPortalCollectionsControl,
        },
        {
          type: 'item',
          labelId: 'insightsPortalDomain.placements.nav',
          route: 'insights-portal-placements-insights',
          accessControl: insightsPortalPlacementsAccessControl,
        },
      ],
    },
    {
      attachTo: NavItem.Reports,
      subNavItems: [
        {
          type: 'item',
          labelId: 'insightsPortalDomain.dataExplorer.nav',
          route: 'insights-portal-custom-report-list',
          accessControl: insightsPortalDataExplorerAccessControl,
        },
      ],
    },
  ],
}

export default definition
